module.exports = __webpack_public_path__ + "static/img/home.0bd8f8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/header/home.png
// module id = c1cF
// module chunks = 7